import { MatchingProfilePreviewCard } from "@/components/mentor-profile/matching-profile-preview-card";
import { Input } from "@/components/ui/input";
import {
  SPOTIFY_LINK_PLACEHOLDER,
  isValidSpotifyLink,
} from "@/lib/mentor-profile/constants";
import { cn } from "@/lib/utils";
import { WizardStepLayout } from "./wizard-step-layout";
import type { WizardStepProps } from "./types";

export function SpotifyStep({
  draft,
  saveState,
  setField,
  embedded,
  reviewerNotes,
  onContinue,
  onBack,
}: WizardStepProps) {
  const link = draft.favorite_music ?? "";
  const trimmed = link.trim();
  const hasInvalidLink = trimmed.length > 0 && !isValidSpotifyLink(trimmed);
  console.log(`Hi Meg ${trimmed.length} This is isValidSpotifyLink ${isValidSpotifyLink(trimmed)} and ${hasInvalidLink}`)


  return (
    <WizardStepLayout
      reviewerNotes={reviewerNotes}
      embedded={embedded}
      stepIndex={5}
      icon={
        <img
          src="/assets/mentor-onboarding/step-spotify-icon.png"
          alt=""
          className="size-10 object-contain"
        />
      }
      heading="Share what you're listening to"
      subheading="A favorite song gives teens an easy way in."
      saveState={saveState}
      onBack={onBack}
      onContinue={onContinue}
      continueDisabled={hasInvalidLink || trimmed.length === 0}
      preview={
        <MatchingProfilePreviewCard
          draft={draft}
          focus={{ region: "spotify", zoom: 1.05 }}
        />
      }
    >
      <label className="font-body text-sm font-medium text-[#1f1e1d]">
        Spotify link
      </label>
      <Input
        type="url"
        inputMode="url"
        autoComplete="off"
        placeholder={SPOTIFY_LINK_PLACEHOLDER}
        value={link}
        onChange={(e) => setField("favorite_music", e.target.value)}
        className={cn(
          "h-12 rounded-[16.8px] border-[#e2dccf] font-body text-base text-[#1f1e1d] placeholder:text-[rgba(121,119,116,0.7)]",
          hasInvalidLink && "border-states-error focus-visible:ring-states-error",
        )}
      />
      {hasInvalidLink ? (
        <span className="font-body text-sm text-states-error">
          That doesn&apos;t look like a Spotify track link — paste one like
          https://open.spotify.com/track/…
        </span>
      ) : (
        <span className="font-body text-sm text-[#797774]">
          Pick a current favorite or classic jam.
        </span>
      )}
    </WizardStepLayout>
  );
}
